import { message } from "antd";
import { domainUrl } from "../../constants";
import { checkAuthorization } from "../../helpers";

const createQuote = (formData) => {

    const { userToken } = checkAuthorization()
    const myHeaders = new Headers()
    // myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', userToken)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formData,
        redirect: 'follow'
    }
    console.log('formdata',formData)
    const url = '/createClientProject'
    return (
        fetch(domainUrl + url, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(result?.message)
                return 1
            }
            else 
                throw result?.message
        })
        .catch(error => {
            message.error(error.message)
            return 0
        })
    )
}

const getProfessionalsByServices= (servicesID)=>{
    const { userToken } = checkAuthorization()
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', userToken)
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(servicesID),
        redirect: 'follow'
    }
    console.log('selected id',servicesID)
    const url = '/getProfessionalsByServices'
    return (
        fetch(domainUrl + url, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                return result?.data
            }
            else 
                throw result?.message
        })
        .catch(error => {
            message.error(error.message || 'Should Select minimum one service')
            return 0
        })
    )
}

const getquoteApi = {
    createQuote,
    getProfessionalsByServices
};

export { getquoteApi };